import { render, staticRenderFns } from "./theAssessmentDetails.vue?vue&type=template&id=6d601487&scoped=true&"
import script from "./theAssessmentDetails.vue?vue&type=script&lang=js&"
export * from "./theAssessmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./theAssessmentDetails.vue?vue&type=style&index=0&id=6d601487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d601487",
  null
  
)

export default component.exports